import { render, staticRenderFns } from "./AscDocMgmtWrapper.vue?vue&type=template&id=2fd245c1&"
import script from "./AscDocMgmtWrapper.vue?vue&type=script&lang=js&"
export * from "./AscDocMgmtWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscDocMgmtWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports